 const data = [
  {
    "id": "AFG",
    "value": 16439
  },
  {
    "id": "AGO",
    "value": 335547
  },
  {
    "id": "ALB",
    "value": 300354
  },
  {
    "id": "ARE",
    "value": 456949
  },
  {
    "id": "ARG",
    "value": 41077
  },
  {
    "id": "ARM",
    "value": 620845
  },
  {
    "id": "ATA",
    "value": 180000
  },
  {
    "id": "ATF",
    "value": 501299
  },
  {
    "id": "AUT",
    "value": 711543
  },
  {
    "id": "AZE",
    "value": 754457
  },
  {
    "id": "BDI",
    "value": 270106
  },
  {
    "id": "BEL",
    "value": 410091
  },
  {
    "id": "BEN",
    "value": 366517
  },
  {
    "id": "BFA",
    "value": 233868
  },
  {
    "id": "BGD",
    "value": 578661
  },
  {
    "id": "BGR",
    "value": 216193
  },
  {
    "id": "BHS",
    "value": 539941
  },
  {
    "id": "BIH",
    "value": 377704
  },
  {
    "id": "BLR",
    "value": 723572
  },
  {
    "id": "BLZ",
    "value": 503363
  },
  {
    "id": "BOL",
    "value": 258765
  },
  {
    "id": "BRN",
    "value": 941811
  },
  {
    "id": "BTN",
    "value": 97165
  },
  {
    "id": "BWA",
    "value": 217562
  },
  {
    "id": "CAF",
    "value": 987935
  },
  {
    "id": "CAN",
    "value": 44000
  },
  {
    "id": "CHE",
    "value": 853210
  },
  {
    "id": "CHL",
    "value": 984945
  },
  {
    "id": "CHN",
    "value": 540665
  },
  {
    "id": "CIV",
    "value": 52985
  },
  {
    "id": "CMR",
    "value": 389485
  },
  {
    "id": "COG",
    "value": 561228
  },
  {
    "id": "COL",
    "value": 127084
  },
  {
    "id": "CRI",
    "value": 91259
  },
  {
    "id": "CUB",
    "value": 152255
  },
  {
    "id": "-99",
    "value": 89736
  },
  {
    "id": "CYP",
    "value": 837803
  },
  {
    "id": "CZE",
    "value": 278603
  },
  {
    "id": "DEU",
    "value": 75138
  },
  {
    "id": "DJI",
    "value": 143679
  },
  {
    "id": "DNK",
    "value": 957504
  },
  {
    "id": "DOM",
    "value": 272320
  },
  {
    "id": "DZA",
    "value": 982308
  },
  {
    "id": "ECU",
    "value": 875322
  },
  {
    "id": "EGY",
    "value": 283809
  },
  {
    "id": "ERI",
    "value": 293519
  },
  {
    "id": "ESP",
    "value": 597935
  },
  {
    "id": "EST",
    "value": 269763
  },
  {
    "id": "ETH",
    "value": 428778
  },
  {
    "id": "FIN",
    "value": 392097
  },
  {
    "id": "FJI",
    "value": 388629
  },
  {
    "id": "FLK",
    "value": 698660
  },
  {
    "id": "FRA",
    "value": 366983
  },
  {
    "id": "GAB",
    "value": 379202
  },
  {
    "id": "GBR",
    "value": 50171
  },
  {
    "id": "GEO",
    "value": 849911
  },
  {
    "id": "GHA",
    "value": 877861
  },
  {
    "id": "GIN",
    "value": 766382
  },
  {
    "id": "GMB",
    "value": 859483
  },
  {
    "id": "GNB",
    "value": 735198
  },
  {
    "id": "GNQ",
    "value": 719124
  },
  {
    "id": "GRC",
    "value": 736461
  },
  {
    "id": "GTM",
    "value": 608252
  },
  {
    "id": "GUY",
    "value": 913836
  },
  {
    "id": "HND",
    "value": 308468
  },
  {
    "id": "HRV",
    "value": 40566
  },
  {
    "id": "HTI",
    "value": 521631
  },
  {
    "id": "HUN",
    "value": 461134
  },
  {
    "id": "IDN",
    "value": 804366
  },
  {
    "id": "IND",
    "value": 518090
  },
  {
    "id": "IRL",
    "value": 526200
  },
  {
    "id": "IRN",
    "value": 850830
  },
  {
    "id": "IRQ",
    "value": 73327
  },
  {
    "id": "ISL",
    "value": 901510
  },
  {
    "id": "ISR",
    "value": 43609
  },
  {
    "id": "ITA",
    "value": 435541
  },
  {
    "id": "JAM",
    "value": 283926
  },
  {
    "id": "JOR",
    "value": 2065
  },
  {
    "id": "JPN",
    "value": 363400
  },
  {
    "id": "KAZ",
    "value": 108746
  },
  {
    "id": "KEN",
    "value": 701258
  },
  {
    "id": "KGZ",
    "value": 522906
  },
  {
    "id": "KHM",
    "value": 73852
  },
  {
    "id": "OSA",
    "value": 260124
  },
  {
    "id": "KWT",
    "value": 499359
  },
  {
    "id": "LAO",
    "value": 54225
  },
  {
    "id": "LBN",
    "value": 58591
  },
  {
    "id": "LBR",
    "value": 836854
  },
  {
    "id": "LBY",
    "value": 129007
  },
  {
    "id": "LKA",
    "value": 335672
  },
  {
    "id": "LSO",
    "value": 991976
  },
  {
    "id": "LTU",
    "value": 116841
  },
  {
    "id": "LUX",
    "value": 178061
  },
  {
    "id": "LVA",
    "value": 157181
  },
  {
    "id": "MAR",
    "value": 349821
  },
  {
    "id": "MDA",
    "value": 757339
  },
  {
    "id": "MDG",
    "value": 439185
  },
  {
    "id": "MEX",
    "value": 962345
  },
  {
    "id": "MKD",
    "value": 380920
  },
  {
    "id": "MLI",
    "value": 205487
  },
  {
    "id": "MMR",
    "value": 184447
  },
  {
    "id": "MNE",
    "value": 955573
  },
  {
    "id": "MNG",
    "value": 735808
  },
  {
    "id": "MOZ",
    "value": 113398
  },
  {
    "id": "MRT",
    "value": 87323
  },
  {
    "id": "MWI",
    "value": 843187
  },
  {
    "id": "MYS",
    "value": 458155
  },
  {
    "id": "NAM",
    "value": 436278
  },
  {
    "id": "NCL",
    "value": 126638
  },
  {
    "id": "NER",
    "value": 706248
  },
  {
    "id": "NGA",
    "value": 153972
  },
  {
    "id": "NIC",
    "value": 231940
  },
  {
    "id": "NLD",
    "value": 139311
  },
  {
    "id": "NOR",
    "value": 308104
  },
  {
    "id": "NPL",
    "value": 704300
  },
  {
    "id": "NZL",
    "value": 685824
  },
  {
    "id": "OMN",
    "value": 446169
  },
  {
    "id": "PAK",
    "value": 169142
  },
  {
    "id": "PAN",
    "value": 744571
  },
  {
    "id": "PER",
    "value": 167162
  },
  {
    "id": "PHL",
    "value": 220125
  },
  {
    "id": "PNG",
    "value": 461100
  },
  {
    "id": "POL",
    "value": 278344
  },
  {
    "id": "PRI",
    "value": 225647
  },
  {
    "id": "PRT",
    "value": 344293
  },
  {
    "id": "PRY",
    "value": 567018
  },
  {
    "id": "QAT",
    "value": 845606
  },
  {
    "id": "ROU",
    "value": 167983
  },
  {
    "id": "RUS",
    "value": 180760
  },
  {
    "id": "RWA",
    "value": 180909
  },
  {
    "id": "ESH",
    "value": 104094
  },
  {
    "id": "SAU",
    "value": 90242
  },
  {
    "id": "SDN",
    "value": 303357
  },
  {
    "id": "SDS",
    "value": 66873
  },
  {
    "id": "SEN",
    "value": 408344
  },
  {
    "id": "SLB",
    "value": 548585
  },
  {
    "id": "SLE",
    "value": 26138
  },
  {
    "id": "SLV",
    "value": 921036
  },
  {
    "id": "ABV",
    "value": 489296
  },
  {
    "id": "SOM",
    "value": 78256
  },
  {
    "id": "SRB",
    "value": 601456
  },
  {
    "id": "SUR",
    "value": 735367
  },
  {
    "id": "SVK",
    "value": 275079
  },
  {
    "id": "SVN",
    "value": 329604
  },
  {
    "id": "SWZ",
    "value": 334568
  },
  {
    "id": "SYR",
    "value": 351015
  },
  {
    "id": "TCD",
    "value": 638257
  },
  {
    "id": "TGO",
    "value": 613166
  },
  {
    "id": "THA",
    "value": 731642
  },
  {
    "id": "TJK",
    "value": 795624
  },
  {
    "id": "TKM",
    "value": 543875
  },
  {
    "id": "TLS",
    "value": 531132
  },
  {
    "id": "TTO",
    "value": 994791
  },
  {
    "id": "TUN",
    "value": 37864
  },
  {
    "id": "TUR",
    "value": 290382
  },
  {
    "id": "TWN",
    "value": 830411
  },
  {
    "id": "TZA",
    "value": 914215
  },
  {
    "id": "UGA",
    "value": 204382
  },
  {
    "id": "UKR",
    "value": 85101
  },
  {
    "id": "URY",
    "value": 649860
  },
  {
    "id": "USA",
    "value": 732005
  },
  {
    "id": "UZB",
    "value": 447485
  },
  {
    "id": "VEN",
    "value": 329638
  },
  {
    "id": "VNM",
    "value": 468890
  },
  {
    "id": "VUT",
    "value": 720782
  },
  {
    "id": "PSE",
    "value": 449486
  },
  {
    "id": "YEM",
    "value": 974024
  },
  {
    "id": "ZAF",
    "value": 779998
  },
  {
    "id": "ZMB",
    "value": 138261
  },
  {
    "id": "ZWE",
    "value": 38703
  },
  {
    "id": "KOR",
    "value": 238248
  }
]

  export default  data